export const SHARE_BUTTON_CONSTANTS = {
    EMAIL: 'email',
    LINK: 'link',
    EMAIL_LINK: 'mailto:?subject=I wanted you to see this ',
    LINK_WRAPPER: 'linkWrapper',
    EMAIL_WRAPPER: 'emailWrapper',
    DATA_AUT_ID: 'data-aut-id',
    SOCIAL: 'social',
    SOCIAL_WRAPPER: 'socialWrapper',
    DATA_URL: 'data-url'
};
